import JudgingEventCard from './JudgingEventCard';

export default JudgingEventCard;
